import { render, staticRenderFns } from "./newSiteSidebarHomepage.vue?vue&type=template&id=5f661456&scoped=true&"
import script from "./newSiteSidebarHomepage.vue?vue&type=script&lang=js&"
export * from "./newSiteSidebarHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f661456",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VSheet})
